import { inject } from "mobx-react";
import { observer } from "mobx-react-lite";
import React, { useEffect, useState, Suspense, lazy } from "react";
import { CircularProgress, withStyles } from "@material-ui/core";
import styles from "./TagsStyle";
import Dialog from "../../../components/Dialog/Dialog";
import CloseIcon from "../../../components/Icon/Close";
import { Button } from "../../../components/ui/Buttons";
import PageTitle from "../../../components/PageTitle/PageTitle";
import { pageConfiguracoes } from "../../../utils/getPageTitle";
import MultiToggleButtons from "../../../components/Button/MultiToggleButtons";

const Auditoria = lazy(() => import("../../../components/Auditoria/Auditoria"));
const InformacoesTags = lazy(() => import("./InformacoesTags"));

const ModalTags = observer(
  ({
    classes,
    auditoriaStore,
    open,
    onClose,
    tagSelecionada,
    openNotification,
    loadTags,
  }) => {
    const [tabSelected, setTabSelected] = useState(0);

    useEffect(() => {
      auditoriaStore.auditoriaProps = {
        ...auditoriaStore.auditoriaProps,
        auditoria: "a tag",
        auditoriaTela: "tag",
      };
    }, []);

    const isEdit = tagSelecionada?.id;
    const getPageTitle = () => {
      const acao = isEdit ? "Editar" : "Nova";
      return pageConfiguracoes(`${acao} tag`);
    };

    const changeTabSelected = async (tab) => {
      if (tab === 1) {
        auditoriaStore.auditoriaProps = {
          ...auditoriaStore.auditoriaProps,
          pageNumber: 0,
          lastPage: false,
          auditorias: [],
        };

        // TODO: Implement audit query for tags
        // auditoriaStore.load = {
        //   query: findAllTagAuditByTagId,
        //   variableName: "tagId",
        //   variableId: tagSelecionada.id,
        // };
        // await auditoriaStore.loadAuditItems();
      }
      setTabSelected(tab);
    };

    const renderTab = () => {
      return tabSelected === 0 ? (
        <InformacoesTags
          onClose={onClose}
          tagSelecionada={tagSelecionada}
          openNotification={openNotification}
          loadTags={loadTags}
        />
      ) : (
        <Auditoria />
      );
    };

    return (
      <>
        <PageTitle title={getPageTitle()} />
        <Dialog
          open={open}
          onClose={onClose}
          classes={{
            paper: classes.dialogPaper,
          }}
          fullWidth={true}
        >
          <div className={classes.modalHeader}>
            <div className={classes.titleModal}>
              {isEdit ? "Editar tag" : "Nova tag"}
            </div>
            <Button
              id="cfg-mta-btn-fec"
              shape="circle"
              bgColor="#FB7676"
              style={{ height: 32, width: 32 }}
              onClick={onClose}
            >
              <CloseIcon />
            </Button>
          </div>
          <div className={classes.containerModal}>
            <MultiToggleButtons
              id="cfg-mta-btn-tab"
              options={["Informações", "Auditoria"]}
              tabSelected={tabSelected}
              changeTabSelected={changeTabSelected}
              classes={{ buttonsContainer: classes.toggleButtons }}
              disabled={!isEdit}
              posicaoDesabilitada={[1]}
            />
            <div className={classes.contentModal}>
              <Suspense fallback={<CircularProgress size={32} />}>
                {renderTab()}
              </Suspense>
            </div>
          </div>
        </Dialog>
      </>
    );
  }
);

const ModalTagsWithStyles = withStyles(styles)(ModalTags);
export default inject("auditoriaStore")(ModalTagsWithStyles);